export enum WidgetId {
  Shipments = 1,
  RecentOrders = 2,
  Orders = 3
}